import { useReduxState } from 'hooks';
import { TimeIndicator } from 'components/common';

interface Props {
  editor: string;
  updatedAt: string;
}

const EditorBlockInfo = ({ editor, updatedAt }: Props) => {
  const { language, messages, theme } = useReduxState();

  return editor ? (
    <div className="info">
      {editor ? (
        <div className="edited">
          {`${editor} ${messages.editorBlockInfoEdited} `}
          <TimeIndicator language={language} timeString={updatedAt} />
        </div>
      ) : null}

      <style jsx>{`
        .info {
          margin-bottom: 7px;
        }
        .edited {
          background-color: ${theme.warningLightColor};
          border-radius: 5px;
          color: ${theme.warningLightTextColor};
          font-size: 1.3rem;
          font-weight: 600;
          margin-bottom: 4px;
          padding: 3px 8px;
        }
      `}</style>
    </div>
  ) : null;
};

export default EditorBlockInfo;
